module.exports = __webpack_public_path__ + "static/fonts/Mont-Light.a2d8c87.woff2";